import { z } from 'zod';
import { driverGroupsSchema } from './driver-groups.schema';

export const driverGroupPagedCollectionSchema = z.object({
  size: z.number().min(0),
  data: driverGroupsSchema,
});

export type DriverGroupPagedCollection = z.infer<
  typeof driverGroupPagedCollectionSchema
>;
